export default "__VITE_ASSET__DtINlI23__"